export const getPrice = (priceId) => ({ prices }) =>
  prices.pricesList.find(({ id }) => id === priceId);
